module.exports = "/_next/static/images/parallax-4-531706168b6500bc078c6a36de97dd85.jpg.webp";